import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/app/src/templates/Main/index.tsx";
import Box from '@material-ui/core/Box';
import Provider from '@/components/Solutions/Provider';
import { HighlightCardWithIcon } from '@/components/HighlightCard';
import IdentityValidationIcon from '@/assets/solutions/identity-validation.webp';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Provider mdxType="Provider">
  
      <Box align="center" paddingY={3} mdxType="Box">
        <h4 {...{
          "id": "know-your-customer-is-really-who-they-say-they-are",
          "style": {
            "position": "relative"
          }
        }}>{`Know your customer is really who they say they are.`}<a parentName="h4" {...{
            "href": "#know-your-customer-is-really-who-they-say-they-are",
            "aria-label": "know your customer is really who they say they are permalink",
            "className": "anchor after"
          }}><svg parentName="a" {...{
              "aria-hidden": "true",
              "focusable": "false",
              "height": "16",
              "version": "1.1",
              "viewBox": "0 0 16 16",
              "width": "16"
            }}><path parentName="svg" {...{
                "fillRule": "evenodd",
                "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
              }}></path></svg></a></h4>
      </Box>
      <Box align="left" mdxType="Box">
        <p>{`Retrieve the full name on the bank accounts along with other identifiable information to complement electronic know your customer (eKYC) procedures.`}</p>
        <p>{`Customer identification systems must provide procedures where the lender can take the information the customer has provided and verify its accuracy against third party sources.`}</p>
      </Box>
      <Box padding={4} mdxType="Box">
        <HighlightCardWithIcon icon={IdentityValidationIcon} mdxType="HighlightCardWithIcon">
          <p>{`For individuals, documentary verification might consist of government-issued, unexpired identification, which includes a photograph. Nondocumentary verification can consist of a bank statement report.`}</p>
          <p>{`There are provisions in the regulation that allows loan issuers to obtain the customer's information from a third party. Obtaining the information is a condition of opening the account; failing to get the information is also a violation of the law.`}</p>
        </HighlightCardWithIcon>
      </Box>
    </Provider>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      